<article class="relative shadow-full rounded-3xl p-6 max-w-[380px] h-[195px]">
  <img [src]="'/images/icons/' + position + 'vnumber.svg'" alt="" class="w-16 absolute left-0 top-5">
  <h3 class="pt-8" [transloco]="'home.advantages.' + title"></h3>
  <p class="text-grey" [transloco]="'home.advantages.' + description"></p>
</article>